import { Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';
import AccessByQualityRatingSubsidy from './AccessByQualityRatingSubsidy';
import AccessBySettingTypeSubsidy from './AccessBySettingTypeSubsidy';
import AccessSubsidized from './AccessSubsidized';
import ErrorBoundary from '../ErrorBoundary';

function Q2Row2() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >

        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            Access to subsidized child care
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={10} sm={6}>
              <MessageBox>
                <ErrorBoundary>
                  <AccessSubsidized />
                </ErrorBoundary>
              </MessageBox>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} align="center">
          <ErrorBoundary>
            <AccessBySettingTypeSubsidy height={245} />
          </ErrorBoundary>
        </Grid>
        <Grid item xs={12} sm={6} align="center">
          <ErrorBoundary>
            <AccessByQualityRatingSubsidy height={245} />
          </ErrorBoundary>
        </Grid>
      </Grid>
    </SubquestionBox>
  );
}

export default Q2Row2;
